// @ts-strict-ignore
import React from 'react'
import { capitalize } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { CustomerDetailsSection } from 'pages/Customers/ConfirmCustomer/CustomerDetails'
import { AddCustomerPayload } from 'types/customers'

interface IndividualCustomerConfirmationProps {
  customer: AddCustomerPayload
}

export const IndividualCustomerConfirmation = ({
  customer,
}: IndividualCustomerConfirmationProps) => {
  const { t } = useTranslation()

  const customerDetails = [
    { label: t('customers.type'), value: capitalize(customer?.customerEntityType?.toLowerCase()) },
    { label: t('customers.externalReference'), value: customer?.externalReference },
    { label: t('customers.representative.firstName'), value: customer?.firstName },
    { label: t('customers.representative.lastName'), value: customer?.lastName },
    { label: t('customers.personalIdNumber'), value: customer?.personalIdNumber },
    { label: t('formFields.dateOfBirth'), value: customer.dateOfBirth.replace(/,/g, '/') },
    { label: t('customers.representative.nationality'), value: customer?.nationalityName },
    customer?.individualCustomerDescription && {
      label: t('customers.internalCustomerDescription'),
      value: customer?.individualCustomerDescription,
    },
  ]

  const addressDetails = [
    {
      label: t('customers.address.address'),
      value: [
        customer?.addressLine1,
        customer?.addressLine2,
        customer?.city,
        ...(customer?.stateName || customer?.stateCode
          ? [customer?.stateName || customer?.stateCode]
          : []),
        customer?.postalCode,
      ]
        ?.filter(Boolean)
        ?.join(', '),
    },
    { label: t('customers.country'), value: customer?.countryName },
  ]

  return (
    <>
      <CustomerDetailsSection customerDetails={customerDetails} />
      <CustomerDetailsSection
        title={t('customers.registeredAddress')}
        customerDetails={addressDetails}
      />
    </>
  )
}
